import type { MenuProps } from '@mui/material';
import { appFormStyles } from '~/modules/guarantees/legacy/styles.ts';
import { MANAGER_STEP3_TEXT } from '../../manager/step3/constants.ts';

export const CLIENT_STEP2_TEXT = {
  sectionStep: '02',
  sectionTitle: MANAGER_STEP3_TEXT.sectionTitle,
  sectionDescription: MANAGER_STEP3_TEXT.sectionDescription,
  documentsStep: '02.1',
  documentsTitle: 'Довідки про установчі документи та органи управління Клієнта',
  documentColumnLabel: 'Документ',
  actionsColumnLabel: 'Дії',
  emptyDocumentName: 'Файл не додано',
  addDocumentButton: 'Додати документ',
  deleteDocumentButton: 'Видалити документ',
  chooseActionButton: 'Обрати дію',
  previewDocumentButton: 'Переглянути',
  downloadDocumentButton: 'Скачати',
  missingFileMessage: 'Файл не завантажено.',
  requiredFoundingDocumentMessage:
    'Додайте довідку про установчі документи та органи управління Клієнта.',
  signButton: 'Підписати',
  signStubMessage: 'Підписання буде підключено пізніше.',
  signSuccessMessage: 'Документи успішно підписано.',
} as const;

export const CLIENT_STEP2_DOCUMENT_FALLBACK_FILE_NAME = 'document';

export const clientDocumentActionMenuSlotProps: MenuProps['slotProps'] = {
  paper: { sx: appFormStyles.actionMenuPaper },
  backdrop: {
    invisible: true,
  },
};
